
import { computed, defineComponent, onMounted, reactive, ref, toRaw, watch } from 'vue'
import TextToolbar from '@/components/Toolbar/TextToolbar.vue'
import { TrinketText } from '@/domain/models/TrinketText'
import { useStore } from '@/store'
import { Tools } from '@/store/state'

export default defineComponent({
    name: 'TrinketGridText',
    components: { TextToolbar },
    props: {
        text: {
            required: true,
            type: Object as () => TrinketText
        }
    },
    setup (props) {
        const store = useStore()
        // Unref and copy object to lose references
        const readonlyText = { ...toRaw(props.text) }
        const mutatedText = reactive(props.text)

        const textElement = ref<HTMLDivElement>()
        const toolbarElement = ref<typeof TextToolbar>()
        const toolbarPosition = ref({
            left: '0px',
            top: '0px'
        })
        const position = ref({
            left: mutatedText.x + 'px',
            top: mutatedText.y + 'px'
        })
        const selected = ref(false)
        const style = computed(() => ({
            fontSize: mutatedText.fontSize + 'px',
            color: mutatedText.color,
            pointerEvents: 'initial'
        }))

        const onKeyDown = (event: KeyboardEvent) => {
            switch (event.key) {
                case 'Escape':
                    event.preventDefault()
                    cancel()
            }
        }

        onMounted(() => {
            // Align text to center
            position.value.left = mutatedText.x - (textElement.value?.getBoundingClientRect().width ?? 2) / 2 + 'px'
            position.value.top = mutatedText.y - store.state.configuration.point.radius * 2 + 'px'

            toolbarPosition.value.left = mutatedText.x - 115 + 'px'
            toolbarPosition.value.top = mutatedText.y - 65 + 'px'
        })

        watch(() => store.state.trinketGrid.selectedTool, selectedTool => {
            style.value.pointerEvents = selectedTool === Tools.TEXT ? 'initial' : 'none'
        })

        const updatePosition = () => {
            // Align text to center when writing
            position.value.left = mutatedText.x - (textElement.value?.getBoundingClientRect().width ?? 2) / 2 + 'px'
        }

        const cancel = () => {
            selected.value = false
            mutatedText.x = readonlyText.x
            mutatedText.y = readonlyText.y
            mutatedText.fontSize = readonlyText.fontSize
            mutatedText.text = readonlyText.text
            mutatedText.color = readonlyText.color
            mutatedText.uuid = readonlyText.uuid
            if (textElement.value && textElement.value) { textElement.value.blur() }
            document.removeEventListener('keydown', onKeyDown)
        }
        const confirm = () => {
            selected.value = false
            mutatedText.text = textElement.value?.innerText.trim() ?? ''
            store.dispatch('updateText', mutatedText)
            document.removeEventListener('keydown', onKeyDown)
        }
        const remove = () => {
            selected.value = false
            console.log('remove')

            store.dispatch('removeText', mutatedText)
            document.removeEventListener('keydown', onKeyDown)
        }
        const updateFontSize = (fontSize: number) => {
            mutatedText.fontSize = fontSize
            updatePosition()
        }
        const updateFontColor = (fontColor: string) => {
            mutatedText.color = fontColor
        }
        const onSelect = () => {
            selected.value = true
            document.addEventListener('keydown', onKeyDown)
        }

        return {
            mutatedText,
            position,
            toolbarPosition,
            selected,
            style,
            textElement,
            toolbarElement,
            cancel,
            confirm,
            remove,
            onSelect,
            updateFontColor,
            updateFontSize,
            updateText: updatePosition
        }
    }
})
